// extracted by mini-css-extract-plugin
export var block = "pif-module--block--RTlaT";
export var customGroupField = "pif-module--customGroupField--ArSHX";
export var customTextField = "pif-module--customTextField--6gpM+";
export var headContainer = "pif-module--headContainer--VYAsn";
export var labelText = "pif-module--labelText--Tv-Qm";
export var none = "pif-module--none--c+8c+";
export var position = "pif-module--position--lPyZh";
export var root = "pif-module--root--xRjW2";